module.exports = __webpack_public_path__ + "img/政企互动.5c84053d.png";